import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';

import reportWebVitals from './reportWebVitals';
import axios from 'axios'

import AppSelector from './components/navigation/AppSelector';
import AppAuthHandler from './components/authentication/AuthHandler'

import { createBrowserRouter, Navigate, redirect, RouterProvider } from 'react-router-dom';
import ErrorPage from './components/navigation/RouterError'

import App from './App';
import DatabaseApp from './DatabaseApp'

import HomeTab from './components/tabs/home/HomeTab'
import HistoryTab from './components/tabs/history/History'
import DashboardsTab from './components/tabs/monitor/DashboardsTab'
import MarketTab from './components/tabs/market/MarketTab'
import EventsTab from './components/tabs/events/Events'
import ConfigureTab from './components/tabs/configure/ConfigureTab'
import SummaryContent from './components/tabs/market/summary/SummaryContent';
import RSATContent from './components/tabs/market/rsat/RSATContent'
import TableContent from './components/tabs/market/table/TableContent'
import RegulationContent from './components/tabs/market/regulation/RegulationContent'
import ForecastsContent from './components/tabs/market/forecasts/ForecastsContent'
import EventBlueprintConfiguration from './components/tabs/configure/events/EventBlueprintConfiguration';
import EventTemplateConfiguration from './components/tabs/configure/events/EventTemplateConfiguration';
import TagBlueprintConfiguration from './components/tabs/configure/tags/TagBlueprintConfiguration';

import DashboardsList from './components/tabs/monitor/DashboardsList'
import LighthouseDashboard from './components/tabs/monitor/lighthouse/Lighthouse'
import TronDashboard from './components/tabs/monitor/tron/Tron'
import ConfigureTronDashboard from './components/tabs/monitor/tron/Configure'
import ConfigureLighthouseDashboard from './components/tabs/monitor/lighthouse/Configure'

import { HomeTab as PalantirHomeTab } from './precious_components/HomeTab'
import { TablesTab } from './precious_components/TablesTab'
import { ViewsTab } from './precious_components/ViewsTab'
import { InverterManagementTab } from './precious_components/InverterWarehouse';
import { PowerBITab } from './precious_components/PowerBI';
import { View } from './precious_components/ViewsTabView';
import Panel from './components/panel/Panel'
import { Text } from '@mantine/core';

import { store } from './redux/store';
import { Provider } from 'react-redux'



if (process.env.NODE_ENV!=="development") {
    let proxy = process.env.REACT_APP_SERVER_PROXY
    if (!proxy) throw new Error("REACT_APP_SERVER_PROXY must be specified when creating non-development build.")
    axios.defaults.baseURL = proxy
}

const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <AppAuthHandler />
      ),
      //errorElement: <ErrorPage />,
      children: [{
            index: true,
            element: <AppSelector />
        }, {
            path: "precious",
            element: <Navigate to="/palantir" replace={true} />
        }, {
            path: "palantir",
            element: <DatabaseApp />,
            children: [{
                index: true,
                element: <PalantirHomeTab />
            }, {
                path: "tables",
                element: <TablesTab />
            }, {
                path: "views",
                element: <ViewsTab />,
                children: [{
                    index: true,
                    element: <Panel className=" section-panel fill-parent"><Text size="lg">Please select a view.</Text></Panel>
                }, {
                    path: ":viewId",
                    element: <View />
                }]
            }, {
                path: "inverter_management",
                element: <InverterManagementTab />
            }, {
                path: "bi",
                element: <PowerBITab />
            }]
        }, {
            path: "pharos",
            element: <App />,
            children: [{
                index: true,
                element: <HomeTab />
            }, {
                path: "history/*",
                element: <Navigate to={"../trends"+window.location.search} replace={true} />
            }, {
                path: "monitor/*",
                element: <Navigate to={"../dashboards"+window.location.search} replace={true} />
            }, {
                path: "trends",
                element: <HistoryTab />
            }, {
                path: "dashboards",
                element: <DashboardsTab />,
                children: [{
                    index: true,
                    element: <DashboardsList />
                }, {
                    path: "lighthouse",
                    children: [{
                        index: true,
                        element: <LighthouseDashboard />,
                    }, {
                        path: "configure",
                        element: <ConfigureLighthouseDashboard />
                    }]
                }, {
                    path: "tron",
                    children: [{
                        index: true,
                        element: <TronDashboard />
                    }, {
                        path: "configure",
                        element:  <ConfigureTronDashboard />
                    }]
                }]
            }, {
                path: "markets",
                element: <MarketTab />,
                children: [{
                    index: true,
                    element: <SummaryContent />
                }, {
                    path: "table",
                    element: <TableContent />
                }, {
                    path: "regulation",
                    element: <RegulationContent />
                }, {
                    path: "rsat",
                    element: <RSATContent />
                }, {
                    path: "forecast",
                    element: <ForecastsContent />
                }]
            }, {
                path: "events",
                element: <EventsTab />
            }, {
                path: "configure",
                element: <ConfigureTab />,
                children: [{
                    index: true,
                    element: <EventBlueprintConfiguration />
                }, {
                    path: "event_templates",
                    element: <EventTemplateConfiguration />
                }, {
                    path: "tag_blueprints",
                    element: <TagBlueprintConfiguration />
                }]
            }]
        }
      ]
    },
]);

ReactDOM.render( 
    <React.StrictMode>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();